import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
// import { WorkOrder, CustomFieldsConfiguration } from '.././wo-models';
// import { WoUpdater, WoUpdaterService } from '.././wo-updater.service';
import { FormControl, FormGroup, FormBuilder, Validators, ValidatorFn, AbstractControl } from '@angular/forms';

import { TranslateService } from '@ngx-translate/core';
import { SharedService } from '../../shared/shared.service';
import { BaseComponent } from '../../shared/base.component';
//import { Customerdetails, CustomerDetailsListEntity, filteroptions } from '.././work-order-models';
import { LoaderService } from '../../shared/loader.service';
import { SerialNoDetails } from '../../shared/shared.model'
import { WoService } from '../../work-order/work-order.service';
import { DatePipe } from '@angular/common';
@Component({
  // moduleId: module.id,
  selector: 'add-edit-serial-number-lookup',
  templateUrl: 'add-edit-serial-number-lookup.component.html'
})
export class SerialNumberAddEditLookupComponent extends BaseComponent implements OnInit {

  @Input() PartId: number;
  @Input() WhId: number;
  @Input() SerialNo: string;
  @Input() serialNumber: SerialNoDetails[];
  @Input() LocationId?: number = null;
  @Input() BinId?: number = null;

  //selectedId: Customerdetails;
  @Output() done = new EventEmitter();
  @Output() CustID = new EventEmitter();
  yearRange: string;
  frmAddEditSerialNo: FormGroup;

  public rowsperOptions: any;
  public getRows: number;
  public isSaveEnabled: boolean;
  constructor(protected translateService: TranslateService, private loaderservice: LoaderService, protected sharedService: SharedService
    , protected woService: WoService
    , private _frm: FormBuilder
    , private datePipe: DatePipe) {
    super(sharedService, translateService)
    this.yearRange = sharedService.yearRange;
    this.rowsperOptions = this.sharedService.getRowsPerOptions();
    this.getRows = this.sharedService.getRows();

  }
  ngOnInit() {

    this.frmAddEditSerialNo = this._frm.group({
      SerialNo: ['', Validators.required],
      ExpiryDate: [null]

    });
  } //onInit ends

  addSerial(formValid: boolean) {
    debugger;
    this.isSaveEnabled = true;
    if (formValid) {
     
      if (this.frmAddEditSerialNo.controls['SerialNo'].value != '') {
        var serial = {
          'SerialNo': this.frmAddEditSerialNo.controls['SerialNo'].value,
          'ExpiryDate': this.frmAddEditSerialNo.controls["ExpiryDate"].value ? new Date(this.frmAddEditSerialNo.controls['ExpiryDate'].value).toDateString() : null
          //'ExpiryDate': this.datePipe.transform(this.frmAddEditSerialNo.controls["ExpiryDate"].value,'shortDate') 
        };
        if (this.serialNumber.find(x => x.SerialNo == this.frmAddEditSerialNo.controls['SerialNo'].value)) {
          this.sharedService.notification.emit({ severity: 'error', summary: this.translate.instant('2057') + " " + this.frmAddEditSerialNo.controls['SerialNo'].value + " " + this.translate.instant('2065') });
        }
        else {
          this.serialNumber.push(serial);
         // this.frmAddEditSerialNo.controls['SerialNo'].setValue('');
          //this.frmAddEditSerialNo.controls['ExpiryDate'].setValue('');
          this.ngOnInit();

        }
      }
    
    }

  }
  ngOnDestroy()
  {
    this.isSaveEnabled = true;
   
  }
  delete(serial: SerialNoDetails) {
    var x = this.serialNumber.indexOf(serial);
    this.serialNumber.splice(x, 1);

  }

  closePopup() {
    this.done.emit(this.serialNumber);
  }


}